/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDownSmallFilled: {
  name: 'down-small-filled';
  data: string;
} = {
  name: 'down-small-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.92 10.037c-.45.139-.733.511-.733.963 0 .434.035.479 1.685 2.126 1.035 1.033 1.564 1.534 1.688 1.596.248.124.632.124.88 0 .124-.062.653-.563 1.688-1.596 1.656-1.653 1.687-1.692 1.683-2.131a.983.983 0 0 0-.543-.885l-.168-.09-3.04-.007c-1.672-.004-3.085.007-3.14.024"/></svg>`
};
